/**
 * Analytics no-op shim.
 *
 * Mixpanel was removed to eliminate bundle weight, network requests during the
 * Lighthouse trace window, and the loader's effect on critical-chain timing.
 *
 * The exported API is preserved so every existing import site keeps compiling
 * and behaves as a silent no-op. Product events still land in the `event_log`
 * table via `eventLog.ts`. If a hosted analytics provider is reintroduced
 * later, swap the implementations here and every call site lights up again.
 */

export function initAnalytics(): void {
  // intentionally empty
}

export function track(_event: string, _props?: Record<string, unknown>): void {
  // intentionally empty
}

export async function identifyCurrentUser(
  _extraProps?: Record<string, unknown>,
): Promise<void> {
  // intentionally empty
}

export function resetAnalytics(): void {
  // intentionally empty
}
